export default {"src":"/_next/static/media/504.d248e9cd.svg","height":154,"width":173,"blurWidth":0,"blurHeight":0};